export function useValidation(initialForm) {
  const { confirmPassword, password } = initialForm;

  const confirmPasswordMessage = () => {
    if (confirmPassword === "" || password === "") {
      return "New Password/Confirm Password is null";
    }
    return null;
  };

  return {
    confirmPassword: confirmPasswordMessage(),
    password: confirmPasswordMessage()
  };
}

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
